"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import VisitItem from "@/views/shopItems/components/VisitItem.vue";
const UUID = require("uuid");
let AddVisitDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.row = "";
    this.itemLoading = true;
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.extEbusinessList = [];
    this.shopMode = false;
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  toContactUs() {
    return __async(this, null, function* () {
      window.open("https://www.kuajingvs.com/contact", "_blank");
    });
  }
  getExtEbusiness() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      try {
        this.itemLoading = false;
        this.extEbusinessList = [];
        const response = yield API.get(`api://base.auth.pro/v1/shops/${this.row.id}/ext_ebusiness`);
        for (let item of response.data.datas) {
          item.shop_ext_ebusiness_guid = item.id;
          item.logo_url = item.logo;
          item.name = (_a = item.ebusiness.name) != null ? _a : "";
          item.account = item.ebusiness.account;
          item.password = item.ebusiness.password;
          item.url = (_b = item.ebusiness.url) != null ? _b : "";
          item.ebusiness_id = (_c = item.ebusiness.id) != null ? _c : "";
          item.ebusiness_platform_guid = (_d = item.ebusiness.id) != null ? _d : "";
          if (item.ebusiness.model === "platform") {
            item.is_custom = false;
          } else {
            item.is_custom = true;
          }
          item.lockAccount = item.ebusiness.lockAccount;
          this.extEbusinessList.push(item);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.itemLoading = true;
      }
    });
  }
  open(row, model, ebusiness_list) {
    this.dialogLoading = false;
    if (model) {
      this.extEbusinessList = ebusiness_list;
      this.row = row;
      this.shopMode = true;
    } else {
      this.row = row;
      this.shopMode = false;
      this.getExtEbusiness();
    }
    this.dialog.visible = true;
  }
  close() {
    if (this.shopMode) {
      this.dialog.visible = false;
      this.$emit("close", this.extEbusinessList);
    } else {
      this.dialog.visible = false;
      this.$emit("refresh");
    }
  }
  refresh(data) {
    return __async(this, null, function* () {
      if (this.shopMode) {
        if (data.method === "add") {
          this.extEbusinessList.push(data.item);
        }
        if (data.method === "edit") {
          let arr = [];
          for (let i = 0; i < this.extEbusinessList.length; i++) {
            if (this.extEbusinessList[i].ebusiness_id === data.item.ebusiness_id) {
              arr.push(data.item);
            } else {
              arr.push(this.extEbusinessList[i]);
            }
          }
          this.extEbusinessList = arr;
        }
        if (data.method === "delete") {
          this.extEbusinessList = this.extEbusinessList.filter((data_item) => {
            return data_item.ebusiness_id !== data.item.ebusiness_id;
          });
        }
      } else {
        yield this.getExtEbusiness();
      }
    });
  }
};
AddVisitDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      VisitItem
    }
  })
], AddVisitDialog);
export {
  AddVisitDialog as default
};
